// hb-lead-source-chart

Directives.ReportsLeadSourceChartDirective = function ReportsLeadSourceChartDirective() {

    // @ngInject
    function ReportsLeadSourceChartDirectiveControllerFunc($element, Chart, $scope, $injector, $timeout, _, $translate, DeviceService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ReportsLeadSourceChartDirectiveController';
        var self = this;
        this._ = _;
        this.chart = null;
        this.DeviceService = DeviceService;
        this.$translate = $translate;
        this.isMobile = this.DeviceService.nxSmallBreakpoint();
        this.noDataTitle = this.isMobile ? this.$translate.instant('LEADSOURCE.NO_DATA._TITLE_MOBILE_') : this.$translate.instant('LEADSOURCE.NO_DATA._TITLE_');


        this.drawSourceLeadGraph = function drawSourceLeadGraph() {

            //Register chart canvas
            $timeout(function () {
                //Chart instance generation
                var context = document.getElementById('leadSourceChart').getContext('2d');

                if (this.chart !==  null) {
                    this.chart.destroy();
                }

                this.chart = new Chart(context, {
                    // The type of chart we want to create
                    type: 'bar',

                    // The data for our dataset
                    data: {
                        labels: this.leadSourceData.labels,
                        datasets: [{
                            backgroundColor: this.leadSourceData.backgroundColor || '#425eff',
                            hoverBackgroundColor: this.leadSourceData.hoverBackgroundColor,
                            data: this.leadSourceData.values,
                        }],
                        tickSign: this.leadSourceData.tickSign,
                    },

                    // Configuration options go here
                    options: {
                        tooltips: {
                            enabled: false,

                            custom: function(tooltipModel) {
                                // Tooltip Element
                                var tooltipEl = document.getElementById('chartjs-tooltip');

                                // Create element on first render
                                if (!tooltipEl) {
                                    tooltipEl = document.createElement('div');
                                    tooltipEl.id = 'chartjs-tooltip';
                                    tooltipEl.innerHTML = "<div class='reports-lead-source__chart-tooltip'></div>";
                                    document.body.appendChild(tooltipEl);
                                }

                                // Hide if no tooltip
                                if (tooltipModel.opacity === 0) {
                                    tooltipEl.style.opacity = 0;
                                    return;
                                }
                                // Set caret Position
                                tooltipEl.classList.remove('above', 'below', 'no-transform');

                                function getBody(bodyItem) {
                                    return bodyItem.lines;
                                }

                                // Set Text
                                if (tooltipModel.body) {
                                    var titleLines = tooltipModel.title || [];
                                    var bodyLines = tooltipModel.body.map(getBody);

                                    var innerHtml = '';

                                    titleLines.forEach(function(title) {
                                        innerHtml += '<div class="reports-lead-source__chart-tooltip__title">' + title + '</div>';
                                    });

                                    bodyLines.forEach(function(body) {
                                        innerHtml += '<div class="reports-lead-source__chart-tooltip__body">' + body + '</div>';
                                    });

                                    innerHtml += '<div class="reports-lead-source__chart-tooltip--arrow reports-lead-source__chart-tooltip--arrow-bottom"></div>';

                                    var tableRoot = tooltipEl.querySelector('div');
                                    tableRoot.innerHTML = innerHtml;
                                }

                                // `this` will be the overall tooltip
                                var position = this._chart.canvas.getBoundingClientRect();

                                // Display, position, and set styles for font
                                tooltipEl.style.opacity = 1;
                                tooltipEl.style.position = 'absolute';
                                tooltipEl.style.left = position.left - (tooltipModel.width / 2 + 10) + window.pageXOffset + tooltipModel.caretX + 'px';
                                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 75 + 'px';
                                tooltipEl.style.pointerEvents = 'none';
                            },

                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    label += Math.round(tooltipItem.yLabel * 100) / 100;
                                    return label + data.tickSign;
                                }
                            }


                        },

                        cornerRadius: 5,
                        fullCornerRadius: false,
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    fontFamily: "'ProximaNova', 'sans-serif'",
                                    fontSize: 12,
                                    fontColor: "#767B84",
                                    autoSkip: false,
                                },

                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                },

                                scaleLabel: {
                                    display: true,
                                    fontColor: "#767B84",
                                    fontFamily: "'ProximaNova', 'sans-serif'",
                                    fontSize: 12,
                                    fontStyle: '600',
                                    labelString : this.isMobile ? '' : this.leadSourceData.xAxesLabel,
                                },
                            }],
                            yAxes: [{

                                ticks: {
                                    fontFamily: "'ProximaNova', 'sans-serif'",
                                    fontSize: 14,
                                    fontColor: "#767B84",
                                    autoSkip: false,
                                    min: 0,
                                    max: this.leadSourceData.yAxesMax,
                                },

                                gridLines: {
                                    offsetGridLines: true,
                                    borderDash: [4, 4],
                                    tickMarkLength:5,
                                    color: '#EEEFF1',
                                    drawBorder: false,
                                    drawTicks: false,

                                },
                                scaleLabel: {
                                    display: true,
                                    fontFamily: "'ProximaNova', 'sans-serif'",
                                    fontSize: 12,
                                    fontStyle: '600',
                                    fontColor: "#767B84",
                                    labelString : this.isMobile ? '' : this.leadSourceData.yAxesLabel,
                                },
                            }]
                        }
                    }
                });
            }.bind(this));

        };

        this.drawSourceLeadGraph();

        $scope.$watchCollection('leadSourceChartVm.leadSourceData', function () {
            self.drawSourceLeadGraph();
        });
    }

    var ReportsLeadSourceChartDirectiveController = Class(Controllers.BaseController, {
        constructor: ReportsLeadSourceChartDirectiveControllerFunc,

        isShowNoData: function isShowNoData() {
            var _isShowNoData = true;
            if (this.leadSourceData.values.length) {
                _isShowNoData = _.every(this.leadSourceData.values, function (value) {
                    return (value === 0);
                });
            }
            return _isShowNoData;
        }
    });
    return {
        scope: {
            leadSourceData: '=',
            chartTitle: '@',
        },

        templateUrl: 'angular/app/modules/core/features/reports/analytics/reports_lead_source_chart_directive_template.html',
        controller: ReportsLeadSourceChartDirectiveController,
        controllerAs: 'leadSourceChartVm',
        bindToController: true
    };
};